import { AnalysisDocument } from "src/app/common/models/analysis-document.model";
import { ImageAnalysisResult } from "src/app/modules/instagram/models/image-analysis-result.model";
import { SentimentAnalysisResult } from "src/app/modules/instagram/models/sentiment-analysis-result.model";
import { deserializeToSpeechSegment, SpeechSegment } from "src/app/modules/speech2text/models/speech-segment.model";

export const speakerGlobalId = "global";

export interface InstagramPost extends AnalysisDocument {
  postId: string;
  profileId: number;
  publicationDate: Date;
  attachmentPreviewPicture: string;
  type: string;
  mediaUrl: string;
  link: string;
  engagement: number;
  impressions: number;
  saved: number;
  videoViews: number;
  likes: number;
  comments: number;
  interactionRate: number;
  reach: number;
  reelsAverageWatchTime: number;
  shares: number;
  sentimentAnalysisResult?: SentimentAnalysisResult;
  imageAnalysisResult?: ImageAnalysisResult;
  filepath: string;
  segments: SpeechSegment[];
  availableLanguages: string[];
}

export const deserializeToInstagramPost = (input: Partial<InstagramPost>): InstagramPost => {
  const partialInstagramPost: Partial<InstagramPost> = {
    ...input,
    iptcTagRefs: input.iptcTagRefs ?? [],
    entityRefs: input.entityRefs ?? [],
    segments: input.segments?.map((segment) => deserializeToSpeechSegment(segment)) ?? [],
    taggingStatus: input.taggingStatus || (input.body ? "TO_BE_TAGGED" : "NO_STATUS"),
  };
  return partialInstagramPost as InstagramPost;
};
